import type { StoreHomeContent } from '../types/store'

// Wartości 1:1 z obecnym hardkodem LAVMAG (index.vue + useBanners.ts).
// Siatka bezpieczeństwa: gdy backend nie zwróci treści (brak seeda / błąd),
// front renderuje dokładnie to, co dziś — regresja zerowa.
//
// ⚠️ To jest treść JEDNEJ MARKI, nie treść neutralna. Nie używaj jej jako
// fallbacku dla dowolnego sklepu — patrz homeContentDefaultForBrand() na końcu
// pliku. Sklep gadżetów pokazywał przez to na QA hasło „MODA LESS WASTE"
// i baner „SUKIENKI — letnia wyprzedaż", bo jego treści nie było jeszcze
// w bazie, a fallback nie znał marki.
export const DEFAULT_HOME_CONTENT: StoreHomeContent = {
  hero: {
    eyebrow: '',
    title: 'Znane marki do -78% taniej przez cały rok',
    text: 'MODA LESS WASTE',
    ctaLabel: 'ZOBACZ PRODUKTY',
    ctaHref: '/search',
    image: '/images/home/hero.png',
  },
  saleBanner: {
    // Obrazki banera są „czyste" (sama fotografia) — nakładkę tekstową i przycisk
    // renderuje front: title = duży nagłówek, text = podtytuł, ctaLabel/ctaHref = przycisk.
    // UWAGA: treść home jest sterowana z backendu (CONTELIZER_HOME_CONTENT / AdminHomeContent);
    // zapisany dokument NADPISUJE te wartości — na QA/prod zaktualizuj baner także w panelu.
    eyebrow: '',
    title: 'SUKIENKI',
    text: 'Letnia wyprzedaż do -70%',
    ctaLabel: 'Zobacz produkty',
    ctaHref: '/odziez-damska/16226-sukienki-damskie',
    image: '/images/home/sukienki-wyprzedaz-desktop.png',
    imageMobile: '/images/home/sukienki-wyprzedaz-mobile.png',
  },
  styleCards: [
    { label: 'Nowości', sub: 'Sprawdź najnowsze oferty', href: '/nowosci', image: '/images/home/nowosci.png' },
    { label: 'Kobieta', sub: 'Coś dla niej', href: '/16190-odziez-damska', image: '/images/home/kobieta.png' },
    { label: 'Mężczyzna', sub: 'Coś dla niego', href: '/16460-odziez-meska', image: '/images/home/mezczyzna.png' },
    { label: 'Dzieci', sub: 'Zadbaj o swoją pociechę', href: '/18093-dziecko', image: '/images/home/dzieci.png' },
    { label: 'Dom i Ogród', sub: 'Dodatki i akcesoria', href: '/16488-dom-i-ogrod', image: '/images/home/lifestyle.png' },
    { label: 'Marki', sub: 'Znajdź coś dla siebie', href: '/marki', image: '/images/home/marki.png' },
  ],
  categoryTabs: [
    { label: 'Nowości', type: 'new' },
    { label: 'Kobieta', type: 'category', id: '16190', href: '/16190-odziez-damska' },
    { label: 'Mężczyzna', type: 'category', id: '16460', href: '/16460-odziez-meska' },
    { label: 'Dziecko', type: 'category', id: '18093', href: '/18093-dziecko' },
    { label: 'Dom i Ogród', type: 'category', id: '16488', href: '/16488-dom-i-ogrod' },
  ],
  about: {
    title: 'O NAS',
    body: 'Ratujemy wadliwe ubrania, którym zapewniamy drugie życie. Dostarczamy produkty od topowych marek i producentów. Jesteśmy sklepem, który od ponad 10 lat aktywnie rozwija swoje działania w branży modowej. Od samego początku naszej działalności wszystkim naszym akcjom towarzyszy klarowna misja – less waste, more fashion. Dzięki tej idei wyrażamy najcenniejsze dla nas wartości – troskę o stan naszej planety oraz modne jakościowe produkty, które otrzymują drugie życie. W LAVMAG tworzymy miejsce przyjazne miłośniczkom oraz miłośnikom ruchu zero waste.',
    image: '/images/home/o-nas.png',
  },
}

/**
 * Treść zapasowa sklepu katalogowego (gadżety reklamowe).
 *
 * Sklep nie sprzedaje, więc nie ma tu wyprzedaży ani dostawy — jedyną konwersją
 * jest zapytanie o wycenę. Obrazki są PUSTE świadomie: materiały graficzne
 * klientki to osobne zadanie (E6.4), a do tego czasu hero renderuje się jako
 * blok tekstowy na tle motywu marki. Brak zdjęcia jest uczciwszy niż fotografia
 * z cudzego sklepu.
 *
 * To wartości ZAPASOWE — docelowo treść ustawia się w panelu (Home content),
 * a zapisany dokument nadpisuje wszystko poniżej.
 */
export const CATALOG_HOME_CONTENT: StoreHomeContent = {
  hero: {
    eyebrow: 'Twoja marka. Nasz koncept.',
    // Hasło wprost od klientki (16.09.2026), wzorowane na monstera.pl. Mówi
    // czym handlujemy, zanim ktokolwiek przewinie stronę — poprzedni tytuł
    // (hasło „Pomysł. Projekt. Marka.", do 30.10.2026 „Pomysł. Forma. Marka.")
    // jest przekazem marki, nie informacją o ofercie,
    // więc schodzi do nadpisu i do bloku zamykającego stronę.
    title: 'GADŻETY REKLAMOWE Z LOGO',
    text: 'Budujemy widoczność Twojej marki. Od wyboru produktu, przez projekt, po profesjonalne znakowanie — zajmujemy się całością.',
    // Wzorzec ma tu „ZAMÓW TERAZ"; u nas nie ma czego zamawiać, jedyną
    // konwersją jest zapytanie ofertowe — stąd inna etykieta i inny cel.
    ctaLabel: 'WYŚLIJ ZAPYTANIE',
    ctaHref: '/contact?temat=wycena',
    // Bez fotografii: klientka poprosiła, żeby na tytułowej było „samo LOGO
    // proles i hasło". Zdjęcie biurka było kadrem stockowym, który mógłby stać
    // na stronie dowolnej innej firmy. Pusty `image` przełącza hero w wariant
    // `hero--no-media` — płaszczyzna w kolorze marki ze znakiem firmowym.
    image: '',
  },
  // Sekcja banera nie renderuje się w trybie katalogowym (patrz index.vue),
  // ale typ wymaga wartości — trzymamy ją pustą, żeby nic nie przeciekło,
  // gdyby ktoś kiedyś włączył tę sekcję dla katalogu.
  saleBanner: {
    eyebrow: '',
    title: '',
    text: '',
    ctaLabel: '',
    ctaHref: '/search',
    image: '',
  },
  // Kafle kategorii dla katalogu budujemy z RZECZYWISTEGO drzewa kategorii
  // sklepu, nie z listy wpisanej w kod — inaczej po replikacji z EasyItem
  // wskazywałyby nieistniejące działy.
  styleCards: [],
  categoryTabs: [
    { label: 'Nowości', type: 'new' },
  ],
  about: {
    title: 'O NAS',
    body: '',
    image: '',
  },
}

/**
 * Treść zapasowa DISCANTO — sklep modowy jak lavmag, ale osobna marka z własną
 * bazą (sprzedawca od 16.10.2026 ten sam, LAV-MAG Patryk Twardy). Dlatego:
 *   - żadnych haseł ani faktów lavmaga („MODA LESS WASTE", „do -78%", „od ponad
 *     10 lat") — teksty neutralne, do podmiany treścią od klienta;
 *   - żadnych ID kategorii: katalog discanto ma własną numerację, a ID lavmaga
 *     dałyby 404. Linki tylko do listingów niezależnych od bazy (/search,
 *     /nowosci, /marki); zakładki produktów tylko typu `new`;
 *   - zdjęcia wyłącznie od klienta (public/brands/discanto/home/), dobrane do
 *     slotów po proporcjach. Slot bez zdjęcia klienta zostaje pusty — nigdy
 *     fotografia lavmaga.
 *
 * Ten sam dokument dostaje backend (seed CONTELIZER_HOME_CONTENT), więc po
 * zapisaniu treści w panelu front pokaże ją zamiast tej.
 */
export const DISCANTO_HOME_CONTENT: StoreHomeContent = {
  hero: {
    eyebrow: '',
    title: 'Odzież i akcesoria znanych marek',
    // Claim z księgi znaku DISCANTO.
    text: 'MARKOWA MODA W LEPSZEJ CENIE',
    ctaLabel: 'ZOBACZ PRODUKTY',
    ctaHref: '/search',
    // 3840×1530 = 2× slotu 1920×765; jasne tło u góry i ciemniejsze u dołu,
    // gdzie stoi biały tytuł.
    image: '/brands/discanto/home/hero-kobieta.jpg',
  },
  saleBanner: {
    eyebrow: '',
    title: 'NOWOŚCI',
    text: 'Sprawdź, co właśnie do nas trafiło',
    ctaLabel: 'Zobacz produkty',
    ctaHref: '/nowosci',
    // 3840×1520 = 2× slotu desktop 1921×760; wariant mobilny 403×325 1:1 ze slotem.
    image: '/brands/discanto/home/baner-mezczyzna-desktop.jpg',
    imageMobile: '/brands/discanto/home/baner-mezczyzna-mobile.jpg',
  },
  // Kafle 806×650 (≈ proporcje kafla na desktopie, ~1,2:1). Trzy, nie sześć:
  // tyle jest celów niezależnych od ID kategorii.
  styleCards: [
    { label: 'Nowości', sub: 'Sprawdź najnowsze oferty', href: '/nowosci', image: '/brands/discanto/home/kafel-nowosci.jpg' },
    { label: 'Marki', sub: 'Znajdź coś dla siebie', href: '/marki', image: '/brands/discanto/home/kafel-marki.jpg' },
    { label: 'Wszystkie produkty', sub: 'Przeglądaj całą ofertę', href: '/search', image: '/brands/discanto/home/kafel-wszystkie-produkty.jpg' },
  ],
  categoryTabs: [
    { label: 'Nowości', type: 'new' },
  ],
  // Sekcja „O nas" na stronie głównej renderuje się tylko u lavmaga; pusta, żeby
  // nic nie przeciekło, gdyby ten warunek kiedyś zniknął.
  about: {
    title: 'O NAS',
    body: '',
    image: '',
  },
}

/**
 * Treść zapasowa właściwa dla marki.
 *
 * Fallback MUSI znać markę: ten sam obraz frontu obsługuje sklepy o zupełnie
 * różnym asortymencie, a treść zapasowa jednego z nich jest dla pozostałych
 * po prostu treścią konkurencji.
 */
export function homeContentDefaultForBrand(brandId: string | null | undefined): StoreHomeContent {
  // `gadzety` to poprzedni kryptonim marki. Zostaje na liście, dopóki inventory
  // nie wjedzie z nowym NUXT_PUBLIC_BRAND — inaczej sklep dostałby w tym oknie
  // treść zapasową lavmaga, czyli hasła o modzie.
  if (brandId === 'proles' || brandId === 'gadzety') return CATALOG_HOME_CONTENT
  if (brandId === 'discanto') return DISCANTO_HOME_CONTENT
  return DEFAULT_HOME_CONTENT
}
